"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Indexes;

var _preact = require("preact");

var _components = require("@insided/shared/services/algolia/components");

var _utils = require("../../utils");

function Indexes(props) {
  var analyticsTags = (0, _utils.getAnalyticsTags)('instant-search');
  var userToken = (0, _utils.getAnalyticsUserToken)();
  return (0, _preact.h)("div", {
    className: "instant-search-indexes"
  }, (0, _preact.h)(_components.Index, {
    indexName: props.communityId
  }, (0, _preact.h)(_components.Configure, {
    hitsPerPage: props.externalSourcesEnabled ? 20 : 25,
    facetingAfterDistinct: true,
    page: props.pageCount,
    facetFilters: props.sourceFilters,
    restrictSearchableAttributes: (0, _utils.getRestrictedSearchableAttributes)(),
    analyticsTags: analyticsTags,
    clickAnalytics: true,
    analytics: true,
    userToken: userToken,
    filters: (0, _utils.getFilters)({
      hiddenCategories: props.hiddenCategories,
      searchInContentCategories: props.searchInContentCategories,
      searchInProductAreas: props.searchInProductAreas
    }, props.includedDataSources)
  })));
}